const EmailTemplates = [
  {
    subject: "Service Rate Update",
    getBody: (locations) => `Dear Valued Customer,

Please find attached our updated price list for hubbing rates.

${locations.map((loc) => `• ${loc}`).join("\n")}

Please contact the account manager if you have any questions.`,
  },
  {
    subject: "Pricing Notification",
    getBody: (locations) => `Hello,

This is to notify you of updated pricing for the following regions:

${locations.map((loc) => `- ${loc}`).join("\n")}

Kindly refer to the attached sheet for complete information.`,
  },
  {
    subject: "Rate Adjustment Notice",
    getBody: (locations) => `Hi Team,

Please be advised that rate adjustments have been made for these areas:

${locations.join(", ")}

Details are attached in the Excel file.`,
  },
  {
    subject: "Updated Service Rates",
    getBody: (locations) => `Dear Customer,

We've updated the service rates for the following countries:

${locations.map((loc) => `> ${loc}`).join("\n")}

The complete list of changes is enclosed in the attached Excel file.`,
  },
];

export default EmailTemplates;
